export function getQueryStringValue(name, string = window.location.search) {
  const escapedName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${escapedName}=([^&#]*)`);
  const results = regex.exec(string);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
